import { useTranslation } from 'react-i18next'
import { RelevanceScoreProps } from '../types'
import { tokens } from '@/locales/translations/tokens';

export const RelevanceScore = ({ value }: RelevanceScoreProps) => {
  const { t } = useTranslation();
  return (
    <div className='flex items-center gap-2 rounded-lg bg-purple-900/40 px-3 py-2 shadow-md backdrop-blur-sm'>
      <div className='flex flex-col'>
        <span className='text-xs font-medium text-purple-200'>{t(tokens.workstation.sources.relevance)}</span>
        <span className='text-sm font-bold text-purple-100'>{value}%</span>
      </div>
      <div className='flex h-8 w-8 items-center justify-center rounded-full border-2 border-purple-500 text-xs font-medium text-purple-200'>
        {value}
      </div>
    </div>
  )
} 